/** "MedSyncIQ" with "IQ" in solid #F07D94: the platform red at 50% over white,
 *  as a solid color because 50%-opacity text renders paler on thin strokes. */
export function MedSyncWordmark() {
  return (
    <>
      MedSync<span className="text-[#F07D94]">IQ</span>
    </>
  );
}
